import { useState } from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';

interface DeleteSheetConfirmationProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
const DeleteSheetConfirmation: React.FC<DeleteSheetConfirmationProps> = ({ open, onClose, onSuccess }) => {
  return (
    <>
      <Modal open={open} onClose={onClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={onClose}>
          Delete Price Sheet
        </ModalTitle>
        <ModalContent small>Are you sure you want to delete this price sheet?</ModalContent>
        <ModalFooter onClose={onClose} onSubmit={onSuccess} submitText="Yes" closeText="Cancel" />
      </Modal>
    </>
  );
};

export default DeleteSheetConfirmation;
